import { QuoteToolEnvironment } from '@lx/quote-tool/lite/shared/types';

/**
 * Quote Tool Lite specific environment type.
 * Extends QuoteToolEnvironment with application-specific properties.
 */
export type QtLiteEnvironment = QuoteToolEnvironment & {
  /**
   * List of locales that should use Right-To-Left (RTL) text direction.
   * Used to determine document direction at runtime based on the active locale.
   */
  RTL_LOCALES: readonly string[];

  /**
   * Base URL of the online-quote-tool application, used by the online courses
   * wayfinder banner to build the link users are redirected to.
   *
   * The host is the same for every market; only the `locale` query parameter
   * varies, which is appended at runtime from the current locale. It is
   * defined per build environment (dev/stage/prod) since it points to a
   * different deployment of online-quote-tool in each one.
   */
  ONLINE_QT_BASE_URL: string;
};
